import Modal from "react-modal";
import ZoomableImage from "./ZoomableImage";

const ImageViewerModal = ({ image, onClose }) => {
  const appElement =
    typeof document !== "undefined" ? document.getElementById("root") : undefined;

  return (
    <Modal
      isOpen={Boolean(image)}
      onRequestClose={onClose}
      contentLabel={image?.title || "Captured image viewer"}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      ariaHideApp={Boolean(appElement)}
      appElement={appElement || undefined}
      overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      className="flex h-[min(90vh,900px)] w-full max-w-6xl flex-col rounded-2xl border border-white/20 bg-slate-900 p-4 shadow-2xl outline-none sm:p-6"
    >
      <div className="mb-4 flex items-center justify-between gap-4">
        <div>
          <p className="text-sm text-gray-400">Capture image</p>
          <h2 className="text-xl font-bold text-white">{image?.title}</h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="h-10 w-10 rounded-full border border-white/20 bg-white/10 text-xl text-white hover:bg-white/20"
          aria-label="Close image viewer"
        >
          ×
        </button>
      </div>
      {image && (
        <ZoomableImage
          src={image.src}
          alt={image.alt}
          className="min-h-0 flex-1"
        />
      )}
    </Modal>
  );
};

export default ImageViewerModal;
